import BlockPadding from '@/components/block-padding';
import { Button, Quote as QuoteComponent } from '@bumble/ui-kit';
import AutoHeight from 'embla-carousel-auto-height';
import useEmblaCarousel from 'embla-carousel-react';

import styles from './quote-carousel-custom.module.scss';

export default function QuoteCarouselCustom({ data }: { data: any }) {
  const { quotes } = data || {};
  // eslint-disable-next-line @babel/new-cap
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [AutoHeight()]);

  return (
    <BlockPadding maxWidth="small">
      <div className={styles.inner}>
        <div className={styles.quotes}>
          <div ref={emblaRef} className={styles.embla}>
            <div className={styles.embla__container}>
              {quotes?.map((quote: any, index: number) => (
                <div key={index} className={`${styles.quote} ${styles.embla__slide}`}>
                  {quote?.badgeText && <div className={styles.heading}>{quote?.badgeText}</div>}

                  <QuoteComponent text={quote?.quote} author={quote?.author} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {quotes?.length > 1 && (
          <div className={styles.controls}>
            <div className={styles.control}>
              <Button icon="arrow-left" isCircle={true} onClick={() => emblaApi?.scrollPrev()} />
            </div>
            <div className={styles.control}>
              <Button icon="arrow-right" isCircle={true} onClick={() => emblaApi?.scrollNext()} />
            </div>
          </div>
        )}
      </div>
    </BlockPadding>
  );
}
